import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerOverlayProps {
  isVisible: boolean;
  isDark: boolean;
}

/**
 * Full-screen loading spinner overlay, portaled to document.body so it covers
 * the sidebar as well as the main content area. Purely presentational.
 */
const LoadingSpinnerOverlay: React.FC<LoadingSpinnerOverlayProps> = ({ isVisible, isDark }) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const iconColor = isDark ? '#51A2FF' : '#2B7FFF';
  const mutedText = isDark ? '#90A1B9' : '#62748E';

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: isDark ? 'rgba(2, 6, 24, 0.75)' : 'rgba(241, 245, 249, 0.75)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Loader2 size={24} style={{ color: iconColor, animation: 'spin 1s linear infinite' }} />
        <span style={{ fontSize: '14px', color: mutedText }}>
          {t('support.loadingTicket') || 'Loading ticket details...'}
        </span>
      </div>
    </div>,
    document.body
  );
};

export default LoadingSpinnerOverlay;
